export default "__VITE_ASSET__DYAtc$_z__"